import { getJson } from "./client";

// Operator-side Jobs (the unit of k8s execution; one or more per
// Workflow). Today the SPA only needs to list them — used by the Index
// management page to detect in-flight SCAN jobs so the Refresh button
// can gate itself.

export type JobStatus =
  | "queued"
  | "starting"
  | "running"
  | "succeeded"
  | "failed"
  | "cancelled";

export const NON_TERMINAL_JOB_STATUSES: ReadonlySet<JobStatus> = new Set([
  "queued",
  "starting",
  "running",
] as const);

export interface JobRow {
  id: string;
  kind: string;
  status: JobStatus;
  k8s_job_name: string | null;
  submitted_by: string;
  submitted_at: number;
  started_at: number | null;
  finished_at: number | null;
  workflow_id: string | null;
  stage_index: number | null;
  progress_completed: number | null;
  progress_total: number | null;
  progress_message: string | null;
  error_summary: string | null;
}

export interface ListJobsResponse {
  jobs: JobRow[];
  limit: number;
  offset: number;
}

export function listJobs(opts: {
  kind?: string;
  status?: JobStatus;
  limit?: number;
  offset?: number;
}): Promise<ListJobsResponse> {
  const q = new URLSearchParams();
  if (opts.kind) q.set("kind", opts.kind);
  if (opts.status) q.set("status", opts.status);
  if (opts.limit !== undefined) q.set("limit", String(opts.limit));
  if (opts.offset !== undefined) q.set("offset", String(opts.offset));
  const qs = q.toString() ? `?${q.toString()}` : "";
  return getJson<ListJobsResponse>(`/api/v1/operator/jobs${qs}`);
}
